export function createObjectUrlFromBlob(data, mimeType) {
    const blob = new Blob(data, { type: mimeType });
    return window.URL.createObjectURL(blob);
}
export function revokeObjectUrl(url) {
    window.URL.revokeObjectURL(url);
}
